import { render, staticRenderFns } from "./sso_secondbuildings.vue?vue&type=template&id=1d19f7b7"
import script from "./sso_secondbuildings.vue?vue&type=script&lang=js"
export * from "./sso_secondbuildings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports